import elementBase from "./elementBase.js";
import vueStore from "../../config.js";
import * as namespaceStore from "../../namespaceStore.js"
import imageFormat from "../definition/imageFormat.js";
import * as mutates from "../../mutations.js";

export default class ImageStatic extends elementBase {
    objectType = "ImageElement";
    _Path = "";
    Format = imageFormat.Ajuster;
    styleColor = 'rgba(149, 83, 12, 0.61)'; // Gris foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this._Path = args.path ? this.getIdFromText(args.path, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("image")) : "";
        this.Format = args.format ? this.getIdFromText(args.format, imageFormat) : this.getIdFromText("Ajuster", imageFormat);
    }
    static get Name() {
        return "Image Statique";
    }

    get FormatName() {
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (!format) {
            return null;
        }
        return format.name;
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "image", description: "Changer l'image", svgComponentIcon: "imageCarouselIcon" },
        ];
    }
    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "image", description: "Changer l'image", svgComponentIcon: "imageCarouselIcon" },
        ];
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "_Path", construct: String, jsType: "String", isRessource: true },
            { propert: "Format", construct: Number, jsType: "Number" }
        ];
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name:"Path", text: "Image", type: "pathInput", dataType: "string", ressourceType: "image" },
            { name: "Format", text: "Format de l'image", type: "selectInput", dataType: "string", options: imageFormat, optionsType: "idSoft" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    set Path(value) {
        this._Path = value;
        if (this.parent && this.parent.id == "COMPOSITION_SELECTION_GRID") {
            vueStore.commit(namespaceStore.THEME + "/" + mutates.UPDATE_POSSIBLE_COMPOSITIONS_THUMBNAIL, {id: this.id, Path: value});
        }
    }
    get Path() {
        if (this._Path == "") {
            return "";
        }
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this._Path);
        if (ressource) {
            return ressource.url;
        }
        return this._Path;
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            backgroundImage: `url(${this.Path})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'absolute',
        }
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style);
        }
        else {
            style.backgroundSize = 'cover';
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            path: "@" + this._Path + "@",
            format: this.FormatName,
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            path: this.Path,
            format: this.FormatName,
        };
        return object;
    }
}
